module.exports = __webpack_public_path__ + "img/certificado6.a913cd79.jpg";